/* tslint:disable */
/* eslint-disable */

export const listSocials = /* GraphQL */ `
  query ListSocials {
    listEntitys(filter: { entityType: { eq: social } }) {
      items {
        attributes {
          url
          icon
        }
      }
    }
  }
`;

export const listSummaries = /* GraphQL */ `
  query listSummaries {
    listEntitys(filter: { entityType: { eq: summary } }) {
      items {
        title
      }
    }
  }
`;

export const listExperiences = /* GraphQL */ `
  query listExperiences {
    entitiesByEndDate(entityType: experience, sortDirection: DESC) {
      items {
        title
        endDate
        attributes {
          location
        }
        startDate
        summary
      }
    }
  }
`;

export const listSkills = /* GraphQL */ `
  query listSkills {
    listEntitys(filter: { entityType: { eq: skill } }) {
      items {
        title
        attributes {
          icon
        }
      }
    }
  }
`;

export const listWorkflows = /* GraphQL */ `
  query listWorkflows {
    listEntitys(filter: { entityType: { eq: workflow } }) {
      items {
        title
      }
    }
  }
`;

export const listProjects = /* GraphQL */ `
  query listProjects {
    listEntitys(filter: { entityType: { eq: project } }) {
      items {
        title
        summary
        attributes {
          description
          technologies
        }
      }
    }
  }
`;

export const listRoundups = /* GraphQL */ `
  query listRoundups {
    listEntitys(filter: { entityType: { eq: roundup } }) {
      items {
        title
        summary
        attributes {
          technologies
        }
      }
    }
  }
`;

export const listEducations = /* GraphQL */ `
  query listEducations {
    entitiesByEndDate(entityType: education, sortDirection: DESC) {
      items {
        title
        summary
        attributes {
          location
        }
        startDate
        endDate
      }
    }
  }
`;
